import { ChartConfiguration } from 'chart.js/auto'
import { GLOBAL_COLORS } from 'theme'
import { ChartPlot } from 'pages/portfolio/storage/interface'

/**
 * Configuration for the Performance linechart
 * @param data
 * @param isDarkMode
 * @returns
 */
export const getPerformanceLineConfig = (timeSeries: ChartPlot[]): ChartConfiguration => {
  const data = {
    labels: timeSeries.map((e) => e.x),
    datasets: [
      {
        label: 'ds1',
        data: timeSeries.map((e) => +e.y),
        tension: 0.1,
        pointBackgroundColor: GLOBAL_COLORS.seashellWhite,
        borderWidth: 2,
        borderColor: GLOBAL_COLORS.coralBlue,
        pointRadius: 0,
        pointHitRadius: 0,
      },
    ],
  }

  return {
    type: 'line',
    data: data,
    options: {
      animation: {
        duration: 0,
      },
      layout: {
        padding: 10,
      },
      hover: {
        mode: 'nearest',
        intersect: true,
      },
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: { display: false },
        tooltip: false,
      },
      elements: {
        point: {
          radius: 0,
        },
      },
      scales: {
        x: { display: false },
        y: { display: false },
        y1: {
          display: false,
        },
        y2: {
          display: false,
          ticks: {
            stepSize: 1,
          },
        },
      },
    },
  } as unknown as ChartConfiguration
}
